
// import React, { useState, useEffect } from "react";
// import { Box, Typography } from "@mui/material";
// import { useTheme } from "@mui/material/styles";
// import {
//   createPosition,
//   updatePosition,
// } from "../../../../../../api/positions";
// import DrawerShell from "./DrawerShell";
// import { getUblPoolStatus } from "../../../../../../api/ublPool";
// import TypeCard from "./TypeCard";
// import MACSOWSelector from "./MACSOWSelector";
// import PositionForm from "./PositionForm";
// import FteSelector from "./FteSelector";

// const SectionHead = ({ children, t }) => (
//   <Typography
//     sx={{
//       fontFamily: "'DM Mono', monospace",
//       fontSize: "9px",
//       letterSpacing: "0.14em",
//       textTransform: "uppercase",
//       color: t.text3,
//       borderTop: `1px solid ${t.border}`,
//       paddingTop: "14px",
//       marginTop: "14px",
//       marginBottom: "10px",
//     }}
//   >
//     {children}
//   </Typography>
// );

// const normalizePosition = (dto) => ({
//   ...dto,
//   startDate: dto.startDate ?? dto.createdAt?.slice(0, 10) ?? null,
//   endDate: dto.endDate ?? dto.endedAt ?? null,
//   allocatedTo: dto.allocatedToName ?? dto.allocatedTo ?? null,
//   allocatedToMac: dto.allocatedToMacName ?? dto.allocatedToMac ?? null,
//   fte: dto.allocatedToFte ?? dto.fte ?? null,
//   billedFte: dto.billedFte ?? null,
// });

// const NewPositionDrawer = ({
//   open,
//   onClose,
//   macs,
//   onCreated,
//   onUpdated,
//   editRow,
//   readOnly = false,
//   initialMac = null,
//   initialSow = null,
// }) => {
//   const theme = useTheme();
//   const t = theme.custom;

//   const isEdit = !!editRow;
//   const isAllocated = isEdit && !!editRow.allocatedTo;

//   // Form state
//   const [positionType, setPositionType] = useState("BIL");
//   const [selectedMac, setSelectedMac] = useState(null);
//   const [selectedSow, setSelectedSow] = useState(null);
//   const [roleTitle, setRoleTitle] = useState("");
//   const [levelCode, setLevelCode] = useState("");
//   const [startDate, setStartDate] = useState("");
//   const [endDate, setEndDate] = useState("");
//   const [fte, setFte] = useState(1.0);

//   // UI state
//   const [errors, setErrors] = useState({});
//   const [apiError, setApiError] = useState(null);
//   const [saving, setSaving] = useState(false);
//   const [ublPoolStatus, setUblPoolStatus] = useState(null);

//   // Fetch UBL pool status whenever UBL type is selected
//   useEffect(() => {
//     if (positionType !== "UBL") {
//       setUblPoolStatus(null);
//       return;
//     }
//     getUblPoolStatus()
//       .then(setUblPoolStatus)
//       .catch((err) => console.error("Failed to load UBL pool status:", err));
//   }, [positionType]);

//   const selectedSowData = macs
//     ?.find((m) => m.macId === selectedMac || m.id === selectedMac)
//     ?.sows?.find((s) => s.sowId === selectedSow || s.id === selectedSow);

//   const headcountCap = selectedSowData?.headcountCap ?? null;

//   // When drawer opens — either reset (create) or pre-fill (edit)
//   useEffect(() => {
//     if (!open) return;

//     setErrors({});
//     setApiError(null);

//     if (isEdit) {
//       setPositionType(editRow.positionType || "BIL");
//       setRoleTitle(editRow.roleTitle || "");
//       setLevelCode(editRow.levelCode || "");
//       setStartDate(editRow.startDate || editRow.createdAt?.slice(0, 10) || "");
//       setEndDate(editRow.endDate || editRow.endedAt?.slice(0, 10) || "");
//       setFte(editRow.billedFte ?? editRow.fte ?? 1.0);

//       const sowId = editRow.sowId;
//       if (sowId && macs?.length) {
//         const ownerMac = macs.find((m) =>
//           m.sows?.some((s) => s.sowId === sowId || s.id === sowId),
//         );
//         if (ownerMac) {
//           setSelectedMac(ownerMac.macId || ownerMac.id);
//           setSelectedSow(sowId);
//         } else {
//           setSelectedMac(null);
//           setSelectedSow(sowId);
//         }
//       } else {
//         setSelectedMac(null);
//         setSelectedSow(null);
//       }
//     } else {
//       setPositionType("BIL");
//       setSelectedMac(initialMac);
//       setSelectedSow(initialSow);
//       setRoleTitle("");
//       setLevelCode("");
//       setStartDate("");
//       setEndDate("");
//       setFte(1.0);
//     }
//   }, [open, isEdit, editRow, macs, initialMac, initialSow]);

//   // Clear SOW when MAC changes (only in create mode)
//   useEffect(() => {
//     if (!isEdit) setSelectedSow(null);
//   }, [selectedMac, isEdit]);

//   const validate = () => {
//     const e = {};
//     if (!selectedSow) e.sow = "Select a SOW";
//     if (!roleTitle.trim()) e.roleTitle = "Role title is required";
//     if (!levelCode) e.levelCode = "Select a level";
//     return e;
//   };

//   const handleSave = async () => {
//     if (!isAllocated) {
//       const e = validate();
//       if (Object.keys(e).length) {
//         setErrors(e);
//         return;
//       }
//     }

//     try {
//       setSaving(true);
//       setApiError(null);

//       if (isEdit) {
//         const id = editRow.positionId || editRow.id;
//         const payload = {};

//         if (!isAllocated) {
//           const originalSow = editRow.sowId;
//           const originalRole = editRow.roleTitle || "";
//           const originalLevel = editRow.levelCode || "";
//           const originalStart =
//             editRow.startDate || editRow.createdAt?.slice(0, 10) || "";

//           if (roleTitle.trim() !== originalRole)
//             payload.roleTitle = roleTitle.trim();
//           if (levelCode !== originalLevel) payload.levelCode = levelCode;
//           if (startDate !== originalStart)
//             payload.startDate = startDate || null;
//           if (selectedSow !== originalSow) payload.sowId = selectedSow;
//         }

//         // fte — always editable in edit mode (even if allocated)
//         // billedFte — always editable in edit mode (even if allocated)
// const originalFte = editRow.billedFte ?? editRow.fte ?? 1.0;
// if (fte !== originalFte) payload.billedFte = fte;

//         // endDate — always check for changes in both modes
//         const originalEnd =
//           editRow.endDate || editRow.endedAt?.slice(0, 10) || "";
//         if (endDate !== originalEnd) payload.endDate = endDate || null;

//         if (Object.keys(payload).length === 0) {
//           setApiError("No changes to save.");
//           return;
//         }

//         const updated = await updatePosition(id, payload);
//         onUpdated?.(normalizePosition(updated));
//       } else {
//         const body = {
//           sowId: selectedSow,
//           positionType,
//           roleTitle: roleTitle.trim(),
//           levelCode,
//           startDate: startDate || null,
//           endDate: endDate || null,
//           billedFte: fte,
//         };
//         const created = await createPosition(body);
//         onCreated?.(normalizePosition(created));
//       }

//       onClose();
//     } catch (err) {
//       const data = err.response?.data;
//       if (data?.error) {
//         setApiError(data.error);
//         return;
//       }
//       if (data?.errors) {
//         setErrors(data.errors);
//         return;
//       }
//       setApiError("Something went wrong. Please try again.");
//     } finally {
//       setSaving(false);
//     }
//   };

//   if (!open) return null;

//   return (
//     <DrawerShell
//       onClose={onClose}
//       onSave={handleSave}
//       saving={saving}
//       apiError={apiError}
//       title={
//         readOnly
//           ? "View Position"
//           : isEdit
//             ? "Edit Position"
//             : "New Position ID"
//       }
//       subtitle={isEdit ? editRow.positionCode : "PMO · Psi360"}
//       readOnly={readOnly}
//     >
//       {isAllocated && (
//         <Box
//           sx={{
//             padding: "8px 12px",
//             borderRadius: "4px",
//             mb: "12px",
//             background: "rgba(214,223,39,0.08)",
//             border: "1px solid rgba(214,223,39,0.25)",
//           }}
//         >
//           <Typography
//             sx={{
//               fontFamily: "'DM Mono', monospace",
//               fontSize: "10px",
//               color: "#D6DF27",
//               letterSpacing: "0.06em",
//             }}
//           >
//             Position is allocated — only End Date can be changed.
//           </Typography>
//         </Box>
//       )}

//       {/* Position Type toggle */}
//       <Box
//         sx={{
//           mb: "4px",
//           pointerEvents: readOnly || isAllocated ? "none" : "auto",
//           opacity: 1,
//         }}
//       >
//         <Typography
//           sx={{
//             fontFamily: "'DM Mono', monospace",
//             fontSize: "9px",
//             letterSpacing: "0.14em",
//             textTransform: "uppercase",
//             color: t.text3,
//             mb: "10px",
//           }}
//         >
//           Position Type
//         </Typography>
//         <Box sx={{ display: "flex", gap: "8px", mb: "4px" }}>
//           <TypeCard
//             label="Billed"
//             sub="Prefix: BIL- · SOW-capped"
//             active={positionType === "BIL"}
//             onClick={() => setPositionType("BIL")}
//           />
//           <TypeCard
//             label="Unbilled"
//             sub="Prefix: UBL- · Pool-capped"
//             active={positionType === "UBL"}
//             onClick={() => setPositionType("UBL")}
//           />
//         </Box>
//       </Box>

//       {/* MAC + SOW selector */}
//       <MACSOWSelector
//         macs={macs}
//         selectedMac={selectedMac}
//         selectedSow={selectedSow}
//         positionType={positionType}
//         sowError={errors.sow}
//         disabled={isAllocated || readOnly}
//         headcountCap={headcountCap}
//         ublPoolStatus={ublPoolStatus}
//         onSelectMac={(id) => {
//           setSelectedMac(id);
//           setErrors((p) => ({ ...p, sow: null }));
//         }}
//         onSelectSow={(id) => {
//           setSelectedSow(id);
//           setErrors((p) => ({ ...p, sow: null }));
//         }}
//       />

//       {/* FTE selector — BIL only */}
//       {positionType === "BIL" && (
//         <FteSelector
//           value={fte}
//           onChange={setFte}
//           disabled={readOnly}
//           t={t}
//         />
//       )}

//       {/* Position details */}
//       <SectionHead t={t}>Position Details</SectionHead>
//       <PositionForm
//         roleTitle={roleTitle}
//         onRoleChange={(e) => {
//           setRoleTitle(e.target.value);
//           setErrors((p) => ({ ...p, roleTitle: null }));
//         }}
//         levelCode={levelCode}
//         onLevelChange={(v) => {
//           setLevelCode(v);
//           setErrors((p) => ({ ...p, levelCode: null }));
//         }}
//         startDate={startDate}
//         onStartChange={(e) => setStartDate(e.target.value)}
//         endDate={endDate}
//         onEndChange={readOnly ? undefined : (e) => setEndDate(e.target.value)}
//         positionType={positionType}
//         errors={errors}
//         isEdit={isEdit}
//         positionCode={editRow?.positionCode}
//         isAllocated={isAllocated}
//         readOnly={readOnly}
//       />
//     </DrawerShell>
//   );
// };

// export default NewPositionDrawer;



import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import {
  createPosition,
  updatePosition,
} from "../../../../../../api/positions";
import DrawerShell from "./DrawerShell";
import { getUblPoolStatus } from "../../../../../../api/ublPool";
import TypeCard from "./TypeCard";
import MACSOWSelector from "./MACSOWSelector";
import PositionForm from "./PositionForm";
import FteSelector from "./FteSelector";

const SectionHead = ({ children, t }) => (
  <Typography
    sx={{
      fontFamily: "'DM Mono', monospace",
      fontSize: "9px",
      letterSpacing: "0.14em",
      textTransform: "uppercase",
      color: t.text3,
      borderTop: `1px solid ${t.border}`,
      paddingTop: "14px",
      marginTop: "14px",
      marginBottom: "10px",
    }}
  >
    {children}
  </Typography>
);

const normalizePosition = (dto) => ({
  ...dto,
  startDate: dto.startDate ?? dto.createdAt?.slice(0, 10) ?? null,
  endDate: dto.endDate ?? dto.endedAt ?? null,
  allocatedTo: dto.allocatedToName ?? dto.allocatedTo ?? null,
  allocatedToMac: dto.allocatedToMacName ?? dto.allocatedToMac ?? null,
  fte: dto.allocatedToFte ?? dto.fte ?? null,
  billedFte: dto.billedFte ?? null,
});

const NewPositionDrawer = ({
  open,
  onClose,
  macs,
  onCreated,
  onUpdated,
  editRow,
  readOnly = false,
  initialMac = null,
  initialSow = null,
}) => {
  const theme = useTheme();
  const t = theme.custom;

  const isEdit = !!editRow;
  const isAllocated = isEdit && !!editRow.allocatedTo;

  // Form state
  const [positionType, setPositionType] = useState("BIL");
  const [selectedMac, setSelectedMac] = useState(null);
  const [selectedSow, setSelectedSow] = useState(null);
  const [roleTitle, setRoleTitle] = useState("");
  const [levelCode, setLevelCode] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [fte, setFte] = useState(1.0);

  // UI state
  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState(null);
  const [saving, setSaving] = useState(false);
  const [ublPoolStatus, setUblPoolStatus] = useState(null);

  // Fetch UBL pool status whenever UBL type is selected
  useEffect(() => {
    if (positionType !== "UBL") {
      setUblPoolStatus(null);
      return;
    }
    getUblPoolStatus()
      .then(setUblPoolStatus)
      .catch((err) => console.error("Failed to load UBL pool status:", err));
  }, [positionType]);

  const selectedSowData = macs
    ?.find((m) => m.macId === selectedMac || m.id === selectedMac)
    ?.sows?.find((s) => s.sowId === selectedSow || s.id === selectedSow);

  const headcountCap = selectedSowData?.headcountCap ?? null;

  // When drawer opens — either reset (create) or pre-fill (edit)
  useEffect(() => {
    if (!open) return;

    setErrors({});
    setApiError(null);

    if (isEdit) {
      setPositionType(editRow.positionType || "BIL");
      setRoleTitle(editRow.roleTitle || "");
      setLevelCode(editRow.levelCode || "");
      setStartDate(editRow.startDate || editRow.createdAt?.slice(0, 10) || "");
      setEndDate(editRow.endDate || editRow.endedAt?.slice(0, 10) || "");
      setFte(editRow.billedFte ?? null);

      const sowId = editRow.sowId;
      if (sowId && macs?.length) {
        const ownerMac = macs.find((m) =>
          m.sows?.some((s) => s.sowId === sowId || s.id === sowId),
        );
        if (ownerMac) {
          setSelectedMac(ownerMac.macId || ownerMac.id);
          setSelectedSow(sowId);
        } else {
          setSelectedMac(null);
          setSelectedSow(sowId);
        }
      } else {
        setSelectedMac(null);
        setSelectedSow(null);
      }
    } else {
      setPositionType("BIL");
      setSelectedMac(initialMac);
      setSelectedSow(initialSow);
      setRoleTitle("");
      setLevelCode("");
      setStartDate("");
      setEndDate("");
      setFte(1.0);
    }
  }, [open, isEdit, editRow, macs, initialMac, initialSow]);

  // Clear SOW when MAC changes (only in create mode)
  useEffect(() => {
    if (!isEdit) setSelectedSow(null);
  }, [selectedMac, isEdit]);

  const validate = () => {
    const e = {};
    if (!selectedSow) e.sow = "Select a SOW";
    if (!roleTitle.trim()) e.roleTitle = "Role title is required";
    if (!levelCode) e.levelCode = "Select a level";
    if (positionType === "BIL" && fte == null) e.fte = "Select a Billed FTE value";
    return e;
  };

  const handleSave = async () => {
    if (!isAllocated) {
      const e = validate();
      if (Object.keys(e).length) {
        setErrors(e);
        return;
      }
    } else if (positionType === "BIL" && fte == null) {
      setErrors({ fte: "Select a Billed FTE value" });
      return;
    }

    try {
      setSaving(true);
      setApiError(null);

      if (isEdit) {
        const id = editRow.positionId || editRow.id;
        const payload = {};

        if (!isAllocated) {
          const originalSow = editRow.sowId;
          
          const originalStart =
            editRow.startDate || editRow.createdAt?.slice(0, 10) || "";

          
          if (startDate !== originalStart)
            payload.startDate = startDate || null;
          if (selectedSow !== originalSow) payload.sowId = selectedSow;
        }
        const originalRole = editRow.roleTitle || "";
          const originalLevel = editRow.levelCode || "";
          if (roleTitle.trim() !== originalRole)
            payload.roleTitle = roleTitle.trim();
          if (levelCode !== originalLevel) payload.levelCode = levelCode;

        // fte — always editable in edit mode (even if allocated)
        // billedFte — always editable in edit mode (even if allocated)
const originalFte = editRow.billedFte ?? null;
if (fte !== originalFte) payload.billedFte = fte;

        // endDate — always check for changes in both modes
        const originalEnd =
          editRow.endDate || editRow.endedAt?.slice(0, 10) || "";
        if (endDate !== originalEnd) payload.endDate = endDate || null;

        if (Object.keys(payload).length === 0) {
          setApiError("No changes to save.");
          return;
        }

        const updated = await updatePosition(id, payload);
        onUpdated?.(normalizePosition(updated));
      } else {
        const body = {
          sowId: selectedSow,
          positionType,
          roleTitle: roleTitle.trim(),
          levelCode,
          startDate: startDate || null,
          endDate: endDate || null,
          billedFte: fte,
        };
        const created = await createPosition(body);
        onCreated?.(normalizePosition(created));
      }

      onClose();
    } catch (err) {
      const data = err.response?.data;
      if (data?.error) {
        setApiError(data.error);
        return;
      }
      if (data?.errors) {
        setErrors(data.errors);
        return;
      }
      setApiError("Something went wrong. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  if (!open) return null;

  return (
    <DrawerShell
      onClose={onClose}
      onSave={handleSave}
      saving={saving}
      apiError={apiError}
      title={
        readOnly
          ? "View Position"
          : isEdit
            ? "Edit Position"
            : "New Position ID"
      }
      subtitle={isEdit ? editRow.positionCode : "PMO · Psi360"}
      readOnly={readOnly}
    >
      {isAllocated && (
        <Box
          sx={{
            padding: "8px 12px",
            borderRadius: "4px",
            mb: "12px",
            background: "rgba(214,223,39,0.08)",
            border: "1px solid rgba(214,223,39,0.25)",
          }}
        >
          <Typography
            sx={{
              fontFamily: "'DM Mono', monospace",
              fontSize: "10px",
              color: "#D6DF27",
              letterSpacing: "0.06em",
            }}
          >
            Position is allocated — only End Date can be changed.
          </Typography>
        </Box>
      )}

      {/* Position Type toggle */}
      <Box
        sx={{
          mb: "4px",
          pointerEvents: readOnly || isAllocated ? "none" : "auto",
          opacity: 1,
        }}
      >
        <Typography
          sx={{
            fontFamily: "'DM Mono', monospace",
            fontSize: "9px",
            letterSpacing: "0.14em",
            textTransform: "uppercase",
            color: t.text3,
            mb: "10px",
          }}
        >
          Position Type
        </Typography>
        <Box sx={{ display: "flex", gap: "8px", mb: "4px" }}>
          <TypeCard
            label="Billed"
            sub="Prefix: BIL- · SOW-capped"
            active={positionType === "BIL"}
            onClick={() => setPositionType("BIL")}
          />
          <TypeCard
            label="Unbilled"
            sub="Prefix: UBL- · Pool-capped"
            active={positionType === "UBL"}
            onClick={() => setPositionType("UBL")}
          />
        </Box>
      </Box>

      {/* MAC + SOW selector */}
      <MACSOWSelector
        macs={macs}
        selectedMac={selectedMac}
        selectedSow={selectedSow}
        positionType={positionType}
        sowError={errors.sow}
        disabled={isAllocated || readOnly}
        headcountCap={headcountCap}
        ublPoolStatus={ublPoolStatus}
        onSelectMac={(id) => {
          setSelectedMac(id);
          setErrors((p) => ({ ...p, sow: null }));
        }}
        onSelectSow={(id) => {
          setSelectedSow(id);
          setErrors((p) => ({ ...p, sow: null }));
        }}
      />

      {/* FTE selector — BIL only */}
      {positionType === "BIL" && (
        <>
          <FteSelector
            value={fte}
            onChange={(v) => { setFte(v); setErrors((p) => ({ ...p, fte: null })); }}
            disabled={readOnly}
            t={t}
          />
          {errors.fte && (
            <Typography sx={{ fontFamily: "'Inter', sans-serif", fontSize: "11px", color: "#c84040", mt: "-4px", mb: "8px" }}>
              {errors.fte}
            </Typography>
          )}
        </>
      )}

      {/* Position details */}
      <SectionHead t={t}>Position Details</SectionHead>
      <PositionForm
        roleTitle={roleTitle}
        onRoleChange={(e) => {
          setRoleTitle(e.target.value);
          setErrors((p) => ({ ...p, roleTitle: null }));
        }}
        levelCode={levelCode}
        onLevelChange={(v) => {
          setLevelCode(v);
          setErrors((p) => ({ ...p, levelCode: null }));
        }}
        startDate={startDate}
        onStartChange={(e) => setStartDate(e.target.value)}
        endDate={endDate}
        onEndChange={readOnly ? undefined : (e) => setEndDate(e.target.value)}
        positionType={positionType}
        errors={errors}
        isEdit={isEdit}
        positionCode={editRow?.positionCode}
        isAllocated={isAllocated}
        readOnly={readOnly}
      />
    </DrawerShell>
  );
};

export default NewPositionDrawer;


